import React, { useState, useEffect, useContext } from "react";
import * as msal from "@azure/msal-browser";
import jwt_decode from "jwt-decode";
import axios from 'axios'

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

export const MsalContext = React.createContext();
export const useMsal = () => useContext(MsalContext);
export const MsalProvider = ({
    children,
    config
}) => {
    const [token, setToken] = useState();
    const [publicClient, setPublicClient] = useState();
    const [loading, setLoading] = useState(false);
    const [popupOpen, ] = useState(false);
    const [loginError, setLoginError] = useState(false);
    const [isAuthenticated,SetIsAuthenticated]=useState(false)
    
    useEffect(() => {
        const pc = new msal.PublicClientApplication(config);
        setPublicClient(pc);
        var url = new URL('https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/authorize?')
        url.searchParams.set('login_hint', localStorage.getItem('mail'))
        pc.handleRedirectPromise().then(async (response) => {
    console.log('handleRedirectPromise response:', response);
    setLoading(false);
    if (response) {
        try {
            const appId = process.env.REACT_APP_APPID + '/access_as_user';
            console.log('clientId usado como scope:', appId);
            const apiToken = await pc.acquireTokenSilent({
                scopes: [appId],
                account: response.account,
                forceRefresh: true
            });
            localStorage.setItem("auth_token", apiToken.accessToken);
            localStorage.setItem("userInfo", apiToken.accessToken);
            let user = jwt_decode(apiToken.accessToken);
            localStorage.setItem("userName", user.name);
            SetIsAuthenticated(true);
        } catch (error) {
            console.log("Erro ao buscar token da API:", error);
            setLoginError(error);
        }
    }
}).catch(error => {
    console.log('handleRedirectPromise error:', error);
    setLoginError(error);
});
        // eslint-disable-next-line
    }, []);

    const login = async (loginRequest, method) => {;
        if (method === "loginRedirect") {
            setLoading(true);
            if (publicClient != null){
                publicClient.loginRedirect(loginRequest)
            }
        }
    }

    const logout = () => {
        localStorage.clear()
        sessionStorage.clear()
        publicClient.logout();
    }

    const passwordReset = async (data) => {
        let response = ""
        try{
            response = await axios.patch((process.env.REACT_APP_CUSTOM_URL || 'http://localhost:8000/v1/') +'reset_password/', data, { headers: { 'Content-Type': 'application/json' }})
        }
        catch{
            response = "Error"
        }
        return response
    }

    const extLogin = async (username, password) => {
        let data={
            email:username,
            password:password
        }
        let response=''
        try{
           response = await axios.post((process.env.REACT_APP_CUSTOM_URL || 'http://localhost:8000/v1') + '/external-auth/', data, { headers: { 'Content-Type': 'application/json' }})
            if(response.data.token) {
                localStorage.setItem("auth_token", response.data.token)
                localStorage.setItem("userInfo", response.data.token)
                let user = jwt_decode(response.data.token)
                localStorage.setItem("userName", user.name)
                SetIsAuthenticated(true)
                return response                
            }
        }
        catch{
            response = 'Error'
            return response
        }  
    }

    // This function can be removed if you do not need to support IE
    const getTokenRedirect = async (apiRequest) => {
        try {
            const token=await publicClient.acquireTokenSilent(apiRequest)
            if(token)
            {
            localStorage.setItem("auth_token",token.accessToken)
            setToken(token.accessToken);
            }
        }
        catch(error) {               
            try{
                 setLoading(true);                
                 publicClient.acquireTokenRedirect(apiRequest);
            }
            catch(error) { 
                console.log(error);
                setLoginError(error);
            }
        }
    }

    const getToken = async (apiRequest,user, method) => {
        const signInType = (isIE || isEdge)? "loginRedirect" : method;
        if(signInType === "loginRedirect") {
             await getTokenRedirect({...apiRequest,account:user});

        } else
        {
             await getTokenRedirect({...apiRequest,account:user});
        }
    }

    return (
        <MsalContext.Provider
            value={{
                token,
                loading,
                popupOpen,
                loginError,
                login,
                logout,
                getToken,
                extLogin,
                passwordReset,
                isAuthenticated
            }}
        >
            {children}
        </MsalContext.Provider>
    );
};